export default __webpack_public_path__ + "img/c9e8d245669d8c96bf396313b49966b0.svg";